import { render, staticRenderFns } from "./AddTaskDialog.vue?vue&type=template&id=22e192a4&scoped=true"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e192a4",
  null
  
)

export default component.exports